/* unplugin-vue-components disabled */import { render } from "./track-topic.vue?vue&type=template&id=453876e8&scoped=true"
import script from "./track-topic.vue?vue&type=script&lang=js"
export * from "./track-topic.vue?vue&type=script&lang=js"

import "./track-topic.vue?vue&type=style&index=0&id=453876e8&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-453876e8"],['__file',"src/pages/pulse/tracker/track-topic.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "453876e8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('453876e8', __exports__)) {
    api.reload('453876e8', __exports__)
  }
  
  module.hot.accept("./track-topic.vue?vue&type=template&id=453876e8&scoped=true", () => {
    api.rerender('453876e8', render)
  })

}


export default __exports__